import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Waiting from './../waiting';
import './../../custom.css';
import './../../pages/invoice.css';
import kiosk from './../../../statics/premCheck/kioskResult.png'
import Aman from './../../../statics/img/aman.png';
import masary from './../../../statics/img/masary.png';
import sadad from './../../../statics/img/sadad.png';
import momkan from './../../../statics/img/momkan.png';
class aman extends Component {
      constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            copied: false,
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
    // copyRef(){
    //     let selectText =  document.getElementById('ref');
    //     selectText.select();
    //     document.execCommand("copy"); 
    // }
    getFirstName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[0]
    }
    getLastName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[namesArr.length - 1];
    }
  handleSubmit(event) {
    //--- strat waiting
    this.setState({waiting: true});
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice_prem/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product_prem/'+ this.state.userData.token;
    }
    let paymentDict;
    if(this.props.sourcePage ==='invoice'){
        paymentDict = {
            "source": {
                "identifier" : "aggregator",
                "subtype": "AGGREGATOR"
             }, "shipping_data": {
                'apartment': "",
                'email': this.state.userData.order_email,
                'floor': "",
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': "",
                'building': "",
                'phone_number': this.state.userData.order_phone,
                'postal_code': "",
                'city': "",
                'country': "",
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': "",
                'extra_description': ''
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.CAGG
        };
        if(this.state.deliveryNeed){
            paymentDict.shipping_data.country = this.state.deliveryData.country;
            paymentDict.shipping_data.state = this.state.deliveryData.state;
            paymentDict.shipping_data.city = this.state.deliveryData.city;
            paymentDict.shipping_data.building = this.state.deliveryData.building;
            paymentDict.shipping_data.street = this.state.deliveryData.street;
            paymentDict.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }else if(this.props.sourcePage ==='product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source": {
                "identifier" : "aggregator",
                "subtype": "AGGREGATOR"
             },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.CAGG
        };
        if(this.state.deliveryNeed){
            paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
            paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
            paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
            paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
            paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
            paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }
    let jsonPaymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, jsonPaymentDict, config)
        .then((resp) => {
        if(resp.data.success === true){
            //succes without url and not delivery
            let allowedAggregators = this.state.userData.allowed_aggregators;
            const splitAggregators = allowedAggregators.split('/');
            const JoinedAggregators = splitAggregators.join(",");
            let AggregatorsAr = [];
            let Logos = [];
            splitAggregators.map(e => {
                if (e === 'aman') {
                    AggregatorsAr.push("آمان");
                    Logos.push(<div className="logo">
                    <img src={Aman}></img>
                    <p><i className="fa fa-phone" aria-hidden="true"></i> 19767</p>
                </div>)
                } else if (e === 'masary') {
                    AggregatorsAr.push("مصاري");
                    Logos.push(<div className="logo">
                    <img src={masary}></img>
                    <p><i className="fa fa-phone" aria-hidden="true"></i> 16994</p>
                </div>)
                } else if (e === 'momkn') {
                    AggregatorsAr.push("ممكن");
                    Logos.push(<div className="logo">
                    <img src={momkan}></img>
                    <p><i className="fa fa-phone" aria-hidden="true"></i> 16379</p>
                </div>);
                } else if (e === 'sadad') {
                    AggregatorsAr.push("سداد");
                    Logos.push(  <div className="logo">
                    <img src={sadad}></img>
                    <p><i className="fa fa-phone" aria-hidden="true"></i> 16529</p>
                </div>);
                } 
            });  
            
            //succes without url and not delivery
             if (allowedAggregators !== null) {
                 this.props.setReqComplete({
                    // head: <strong>Pending Payment</strong>, 
                    body:
                        <>
                        <div className="kioskPrem">
                            <img src={kiosk}></img>
                            <h4>Order received successfully</h4>
                            <div className="refNum">
                                <div className="refNumDesc">
                                <p>Reference number</p>
                                <p>الرقم المرجعي</p>
                                    </div>
                                <p>{resp.data.bill_reference}
                                <CopyToClipboard text={resp.data.bill_reference}
                                    onCopy={() => this.setState({copied: true})}>
                                    <button className="copyBtn"><i className="fa fa-clipboard"></i></button>
                                    </CopyToClipboard>
                                    </p>
                            </div>
                            </div>
                            <div className="StepPayment">
                            <p className="kiostDet">
                            Payment Steps:
                            </p>
                            <ul className="listSteps">
                                <li>Go to the nearest ( {JoinedAggregators} ) outlet.</li>
                                <li> Ask for Madfouaat Motanouea Accept.</li>
                                <li>Provide your reference number.</li>
                                </ul>
                            </div>
                            <div className="StepPayment">
                            <p className="kiostSteps">
                            :خطوات الدفع
                            </p>
                                <ul className="listStepsAR">
                                <li> اذهب لأقرب كشك ({AggregatorsAr.join(',')}).</li>
                                <li> اسأل علي (مدفوعات اكسبت المتنوعة ).</li>
                                <li> قدم الرقم المرجعي الخاص بك لتتمكن من الدفع.</li>
                                </ul>
                                </div>
                            <div className="logos">
                            <div className="addressParagh">
                                <p>Find the nearest outlet</p>
                                <p>أعرف اقرب فرع لك</p>
                                </div>
                                 <div className='col-xs-12 col-sm-8 col-sm-push-2 col-md-8 col-md-push-2 col-lg-8 col-lg-push-2 gridMessage'>
                                     {Logos}
                                    <p className="thanx">Thank you for using Paymob Services</p>
                                    </div>
                            </div>   
                        </>
                      
                });
            
            } else {
                this.props.setReqComplete({
                    head: 'Pending Payment', body:
                        <div className="errorBodyMessage">
                            Your bill reference is <strong>{resp.data.bill_reference}</strong>
                            <br />Please head to the nearest Aman outlet, ask for "<strong>Madfouaat Motanouea Accept</strong>" and provide your bill reference.
                            <br />
                            Thank you for choosing Paymob Accept
                            </div>
                });
            }
        }else{
            //succes = false
            this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
        }
    })
    .catch((err) => {
        //--- end waiting
        this.setState({waiting: false});
        if(err.response.status === 404){
            alert('Please check your internet connection and try again.');
        }
    });
    event.preventDefault();
  }

    render() {
        let allowedAggregators = this.state.userData.allowed_aggregators;
        const splitAggregators = allowedAggregators.split('/');
        const JoinedAggregators = splitAggregators.join(",");
        let AggregatorsAr=[]
        splitAggregators.map(e => {
            if (e === 'aman') {
                AggregatorsAr.push("آمان");
            } else if (e === 'masary') {
                AggregatorsAr.push( "مصاري")
            } else if (e === 'momkn') {
                AggregatorsAr.push("ممكن")
            } else if (e === 'sadad') {
                AggregatorsAr.push("سداد")
            } 
        });
    return (
        <div className="premPanel">
            <div className="premHeader" >
                <h2>Kiosk DETAILS</h2>
            </div>
            <div className="panel-body kioskFormBody" id="card_content">
                {this.state.waiting?
                    <Waiting height="163px" />
                :
                    <Form onSubmit={this.handleSubmit}>
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div>
                                    <p className="confirmParagraph">Upon confirmation, an email will be sent to you containing your reference number which you will use at any <strong>( {JoinedAggregators} )</strong> outlet.</p>
                                    <br />
                                    <p style={{ textAlign: "right", color: "#5A75A7" }}>بعد التأكيد, سنرسل لك بريد إلكتروني يحتوي علي الرقم المرجعي للمدفوعات لتستخدمه في اقرب فرع من فروع <strong>( {AggregatorsAr.join(',')} )</strong></p>
                                </div>
                               
                            </div>
                        </div>
                        <br/>
                        <div className='text-center'>
                            <Button className="btn btn-primary active premBtn">CONFIRM</Button>
                        </div>
                    </Form>  
                }              
            </div>
        </div>
    );
  }
}

export default aman;
